import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import Htag from "../typography/Htag";
import Flx from "./Flx";

const ScreenHeader = ({
  children,
  title,
  description,
  descriptionContent,
  endContent,
  borderBottom,
  suppressBottomPadding,
  titleTopContent,
  titleBottomContent,
  titleEndContent,
  sx,
  fw,
}) => {
  const styles = useMemo(() => {
    return {
      inner: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1,
      },
      ...sx,
    };
  }, [sx]);
  return (
    <DashboardScreenAppBar
      suppressBottomPadding={suppressBottomPadding}
      borderBottom={borderBottom}
    >
      <Box className="header-inner-wrapper" sx={styles.inner}>
        <TitleRenderer
          endContent={endContent}
          title={title}
          description={description}
          descriptionContent={descriptionContent}
          titleEndContent={titleEndContent}
          titleTopContent={titleTopContent}
          titleBottomContent={titleBottomContent}
        />
        {endContent}
      </Box>
      {children}
    </DashboardScreenAppBar>
  );
};

const TitleRenderer = ({
  title,
  description,
  descriptionContent,
  titleTopContent,
  titleBottomContent,
  titleEndContent,
}) => {
  return (
    <>
      <Flx column g={1} sx={{ flexGrow: 1 }}>
        {titleTopContent}

        {titleEndContent ? (
          <Flx ac wrap>
            <Htag
              h1
              sx={{ color: "var(--titleColor)", fontSize: "24px" }}
              weight="bold"
              size={300}
            >
              {title}
            </Htag>
            {titleEndContent}
          </Flx>
        ) : (
          <Htag
            h1
            sx={{ color: "var(--titleColor)", fontSize: "24px" }}
            weight="bold"
            size={300}
          >
            {title}
          </Htag>
        )}
        {titleBottomContent}
        {description ? (
          <Typography size={200} variant="body1" sx={{ paddingLeft: "1px" }}>
            {description}
          </Typography>
        ) : null}
        {descriptionContent ? descriptionContent : null}
      </Flx>
    </>
  );
};

const DashboardScreenAppBar = ({
  children,
  borderBottom,
  suppressTopPadding,
  suppressBottomPadding,
  sx,
  fw,
}) => {
  const defaultPaddingConst = 2;
  const styles = useMemo(() => {
    return {
      backgroundColor: "#fff",
      borderBottom: borderBottom ? `1px solid ${grey[200]}` : null,
      pt: suppressTopPadding ? 0 : defaultPaddingConst,
      pr: fw ? 0 : defaultPaddingConst,
      pb: suppressBottomPadding ? 0 : defaultPaddingConst,
      pl: fw ? 0 : defaultPaddingConst,
      position: "relative",
      ...sx,
    };
  }, [sx, fw, suppressTopPadding, suppressBottomPadding, borderBottom]);
  return (
    <Box component="header" sx={styles}>
      {children}
    </Box>
  );
};

export default ScreenHeader;
